import axios from "axios";

export const BRANCH_URL = "/Branch";
export const SECTION_URL = "/Section";
export const PERSONNEL_TYPE_URL = "/PersonnelType";
export const USER_ASSIGNMENT_URL = "/UserAssignment";

/** Mevcut Okulun Kullanıcı Grubu Listesini Elde Eder */
export function getList() {
  return axios.get(USER_ASSIGNMENT_URL);
}

/** Mevcut Okulun Mevcut Dönemdeki Belli Bir Personel Kullanıcı ve Kullanıcı Grubu Listesini Elde Eder */
export function getPersonnelUserAndUserGroups(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetPersonnelUserAndUserGroups`, queryParams);
}

/** Mevcut Okulun Mevcut Dönemdeki Belli Bir Personel Kullanıcı ve Kullanıcı Grubu Listesini Sayfalama Olmadan Elde Eder */
export function getAllPersonnelUserAndUserGroups(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetAllPersonnelUserAndUserGroups`, queryParams);
}

/** Mevcut Okulun Mevcut Dönemdeki Belli Bir Öğretmen Kullanıcı ve Kullanıcı Grubu Listesini Elde Eder */
export function getTeacherUserAndUserGroups(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetTeacherUserAndUserGroups`, queryParams);
}

/** Mevcut Okulun Mevcut Dönemdeki Belli Bir Öğretmen Kullanıcı ve Kullanıcı Grubu Listesini Sayfalama Olmadan Elde Eder */
export function getAllTeacherUserAndUserGroups(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetAllTeacherUserAndUserGroups`, queryParams);
}

/** Mevcut Okulun Mevcut Dönemdeki Belli Bir Öğrenci Kullanıcı ve Kullanıcı Grubu Listesini Elde Eder */
export function getStudentUserAndUserGroups(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetStudentUserAndUserGroups`, queryParams);
}

/** Mevcut Okulun Mevcut Dönemdeki Belli Bir Öğrenci Kullanıcı ve Kullanıcı Grubu Listesini Sayfalama Olmadan Elde Eder */
export function getAllStudentUserAndUserGroups(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetAllStudentUserAndUserGroups`, queryParams);
}

/** Mevcut Okulun Mevcut Dönemdeki Belli Bir Veli Kullanıcı ve Kullanıcı Grubu Listesini Elde Eder */
export function getParentUserAndUserGroups(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetParentUserAndUserGroups`, queryParams);
}

/** Mevcut Okulun Mevcut Dönemdeki Belli Bir Veli Kullanıcı ve Kullanıcı Grubu Listesini Sayfalama Olmadan Elde Eder */
export function getAllParentUserAndUserGroups(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetAllParentUserAndUserGroups`, queryParams);
}

/** Mevcut Okulun Kullanıcı Grubu Listesini Elde Eder */
export function getUserGroups() {
  return axios.get(`${USER_ASSIGNMENT_URL}/GetUserGroups`);
}

/** Mevcut Okulun Belli Bir Personel Kullanıcı Listesini Elde Eder */
export function getPersonnelUsers(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetPersonnelUsers`, queryParams);
}

/** Mevcut Okulun Belli Bir Öğretmen Kullanıcı Listesini Elde Eder */
export function getTeacherUsers(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetTeacherUsers`, queryParams);
}

/** Mevcut Okulun Belli Bir Öğrenci Kullanıcı Listesini Elde Eder */
export function getStudentUsers(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetStudentUsers`, queryParams);
}

/** Mevcut Okulun Belli Bir Veli Kullanıcı Listesini Elde Eder */
export function getParentUsers(queryParams) {
  return axios.post(`${USER_ASSIGNMENT_URL}/GetParentUsers`, queryParams);
}

/** Mevcut Okulun Personel Türü Listesini Elde Eder */
export function getPersonnelTypes() {
  return axios.get(`${PERSONNEL_TYPE_URL}/GetPersonnelTypes`);
}

/** Mevcut Okulun Branş Listesini Elde Eder */
export function getBranches() {
  return axios.get(`${BRANCH_URL}/GetBranches`);
}

/** Mevcut Okulun Şube Listesini Elde Eder */
export function getSections() {
  return axios.get(`${SECTION_URL}/GetSections`);
}

/** Belli Bir Kullanıcı Grubuna Ait Kullanıcı Listesini Elde Eder */
export function getUserIds(userGroupId, userType) {
  return axios.get(`${USER_ASSIGNMENT_URL}/${userGroupId}/${userType}`);
}

/** Belli Bir Kullanıcı Grubuna Ait Kullanıcı Listesini Kaydeder */
export function saveUsers(userType, userGroupId, userIds) {
  return axios.post(USER_ASSIGNMENT_URL, { userType, userGroupId, userIds });
}

/** Belli Bir Kullanıcı Listesini İlgili Kullanıcı Gruplarından Çıkarır */
export function removeUsers(ids) {
  return axios.post(`${USER_ASSIGNMENT_URL}/Remove`, { ids });
}